import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

import { ShipmentsService } from "../../../services/shipment/shipments";
import { callErrorToast } from "../../../utilities";
import { dictionary } from "../../../utilities/dictionary";

export const ConfirmShipmentContext = createContext();

const shipmentsService = new ShipmentsService();

const ConfirmShipmentProvider = ({ children, data, callback }) => {
  const [shipments, setShipments] = useState(data);
  const [shipmentsError, setShipmentsError] = useState(null);
  const [shipmentsLoader, setShipmentsLoader] = useState(false);
  const prevShipmentsError = useRef();

  const confirmShipments = () => {
    setShipmentsLoader(true);
    const promises = shipments.map((elem) => {
      return shipmentsService.confirm(elem);
    });
    Promise.all(promises)
      .then((response) => {
        setShipmentsLoader(false);
        callback();
      })
      .catch((err) => {
        setShipmentsLoader(false);
        setShipmentsError(err);
      });
  };

  useEffect(() => {
    if (
      shipmentsError &&
      JSON.stringify(prevShipmentsError.current) !==
        JSON.stringify(shipmentsError)
    ) {
      callErrorToast(shipmentsError, dictionary);
    }
  }, [shipmentsError]);

  return (
    <ConfirmShipmentContext.Provider
      value={{
        shipments,
        shipmentsError,
        shipmentsLoader,
        confirmShipments,

        callback,
      }}
    >
      {children}
    </ConfirmShipmentContext.Provider>
  );
};

const useConfirmShipmentContext = () => {
  return useContext(ConfirmShipmentContext);
};

export { ConfirmShipmentProvider, useConfirmShipmentContext };
